import React from "react";
import styled from "styled-components";
import { Icon } from "antd";

const StyledOption = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .subtitle {
    margin-left: 8px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
  }

  /* Hide description if it's the selected option */
  .description {
    display: none;
  }

  .anticon {
    width: 20px;
    height: 20px;
    font-size: 12px;
    margin-right: 8px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  /* Only apply custom styles if item is inside the dropdown menu */
  .ant-select-dropdown-menu & {
    align-items: flex-start;
    padding: 12px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    transition: border-color 0.2s;

    .anticon {
      width: 30px;
      height: 30px;
      font-size: 16px;
      margin-right: 12px;
    }

    .wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .header {
      margin-bottom: 2px;

      .title {
        font-weight: bold;
      }
    }

    .description {
      display: block;
      font-size: 12px;
    }
  }
`;

export const DropdownContainer = styled.div`
  .ant-select-dropdown-menu {
    max-height: 300px;
  }

  .ant-select-dropdown-menu-item {
    padding-left: 12px !important;
    padding-right: 12px !important;
    background-color: transparent !important;

    &:hover ${StyledOption} {
      border-color: ${({ theme }) => theme["@primary"]};
    }
  }
`;

export const Option = ({
  title,
  subtitle,
  description,
  icon,
  iconColor,
  iconBackgroundColor
}) => {
  return (
    <StyledOption>
      <Icon
        type={icon}
        style={{
          color: iconColor,
          backgroundColor: iconBackgroundColor
        }}
      />
      <div className="wrapper">
        <div className="header">
          <span className="title">{title}</span>
          {subtitle && <span className="subtitle">{subtitle}</span>}
        </div>
        <span className="description">{description}</span>
      </div>
    </StyledOption>
  );
};
